// base
import React from 'react';
import { useHistory } from 'react-router-dom';

// style
import { StyledAuthorizedResult } from './style';

// routes
import { ROUTE_CHART_DASHBOARD } from 'routes/const';

// libraries
import { Button, Container, Typography } from '@mui/material';

export const AuthorizedResult: React.FC = () => {
  const history = useHistory();

  const goHome = () => {
    history.push(ROUTE_CHART_DASHBOARD);
  };

  return (
    <StyledAuthorizedResult>
      <Container
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      >
        <Typography variant="h2" gutterBottom>
          403
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Sorry, you are not authorized to access this page.
        </Typography>
        <Button variant="outlined" color="primary" onClick={goHome}>
          Go Home
        </Button>
      </Container>
    </StyledAuthorizedResult>
  );
};
